<template>
  <v-row class="mb-13">
    <v-col cols="12" sm="6">
      <div class="title">🚀 Create Your First Automation</div>
    </v-col>
    <v-col cols="12" sm="6" class="d-flex justify-end">
      <v-btn primary :to="{ name: 'signalspro' }">+ Create Automation</v-btn>
    </v-col>
    <v-col cols="12" sm="6" md="4"
      ><v-card
        class="d-flex flex-column rounded"
        elevation="5"
        min-height="430"
        height="100%"
      >
        <v-card-title>Launch Your Strategy Now! </v-card-title>
        <v-img
          :src="require(`@/assets/dashboard-1-exp.png`)"
          gradient="to bottom, rgba(0,11,21,.1), rgba(0,11,2,.5)"
        >
        </v-img>
        <v-card-actions class="d-flex justify-center mt-auto">
          <v-btn
            class="rounded-lg text-none"
            primary
            :to="{ name: 'signalspro' }"
          >
            Create an Automation
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="4"
      ><v-card
        class="d-flex flex-column rounded"
        elevation="5"
        min-height="430"
        height="100%"
      >
        <v-card-title>Read our software tour</v-card-title>
        <v-img
          :src="require(`@/assets/dashboard-2-ebook.png`)"
          gradient="to bottom, rgba(0,11,21,.1), rgba(0,11,2,.5)"
        >
        </v-img>
        <v-card-actions class="d-flex justify-center mt-auto">
          <v-btn class="rounded-lg text-none" primary>
            <a href="https://pxl.to/hizsnhc" target="_blank"
              >Download the playbook</a
            >
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="4"
      ><v-card
        class="d-flex flex-column rounded"
        elevation="5"
        min-height="430"
        height="100%"
      >
        <v-card-title>Schedule an Onboarding call</v-card-title>
        <v-img
          :src="require(`@/assets/dashboard-3-Gmeet.svg`)"
          gradient="to bottom, rgba(0,11,21,.1), rgba(0,11,2,.5)"
        >
        </v-img>
        <v-card-text>
          <p class="font-weight-black">
            Automated Trading Strategy Consultation & Onboarding
          </p>
          <p class="pl-4"><i>Who is this for?</i></p>
          <p class="px-4">
            &#x2022; Traders on Tradovate or Interactive Brokers seeking to
            automate their strategies.
          </p>
          <p class="ma-0 pa-0 font-weight-black">Investment: $110 USD”</p>
        </v-card-text>
        <v-card-actions class="d-flex justify-center mt-auto">
          <v-btn class="rounded-lg text-none" primary>
            <a
              href="https://tidycal.com/proteryx/introductory-call"
              target="_blank"
              >Consultation & Onboarding</a
            >
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DashAutomations",
  components: {},
  data() {
    return {
      mock: false,
      debug: false,
    };
  },
  methods: {},
  computed: {},
  mounted() {},
};
</script>
<style lang="scss">
.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
}
</style>
